<span *ngIf="typingMessage" [@snFadeIn] [@snFadeOut]>{{ typingMessage }}</span>
